interface EventDescriptionProps {
  description: string
}

export default function EventDescription({
  description,
}: EventDescriptionProps) {
  return (
    <div className="bg-boldness/50 flex-1 overflow-y-auto rounded-xl p-4 shadow-lg backdrop-blur-md animate-fade-in-up animation-delay-800">
      <h2 className="font-heading text-strategy-gold mb-2 text-base font-bold tracking-wide uppercase md:text-lg">
        Over dit evenement
      </h2>
      <p className="font-body text-freedom/90 text-xs leading-relaxed md:text-sm">
        {description}
      </p>
    </div>
  )
}
